import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

/** Footer links to Terms and Privacy for auth screens. */
export default function AuthLegalLinks({ className = '' }) {
  const { t } = useLanguage();
  return (
    <div className={`flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-gray-500 ${className}`}>
      <Link to="/terms" className="text-blue-600 hover:underline">
        {t('legal.terms')}
      </Link>
      <Link to="/privacy" className="text-blue-600 hover:underline">
        {t('legal.privacy')}
      </Link>
    </div>
  );
}
